// extracted by mini-css-extract-plugin
module.exports = {"root":"BackToOverview__root--DgL_B","icon":"BackToOverview__icon--Wtg-j"};